/* tabbed collection list */
 
/* end of tabbed collection list */

/* featured collectin */
 document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".tabbed-section").forEach(section => {
    const buttons = section.querySelectorAll(".tab-button");
    const contents = section.querySelectorAll(".tab-content");

    // Init first visible tab's slider
    const initialVisible = section.querySelector(".tab-content:not(.hidden) .slide_featured");
    if (initialVisible) {
      $(initialVisible).slick({
        slidesToShow: 4.1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3.1 }},
          { breakpoint: 767, settings: { slidesToShow: 2.1, arrows:false }},
          { breakpoint: 480, settings: { slidesToShow: 1.1 }}
        ]
      });
    }

    buttons.forEach(btn => {
      btn.addEventListener("click", function () {
        buttons.forEach(b => b.classList.remove("active"));
        contents.forEach(c => c.classList.add("hidden"));

        this.classList.add("active");
        const tabId = this.getAttribute("data-tab");
        const currentTab = section.querySelector(`#${tabId}`);
        currentTab.classList.remove("hidden");

        // Initialize or refresh the slider inside this tab
        const $slider = $(currentTab).find(".slide_featured");

        // Destroy and reinit every time (avoids bugs)
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }

        setTimeout(() => {
          $slider.slick({
            slidesToShow: 4.1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            responsive: [
              { breakpoint: 1024, settings: { slidesToShow: 3.1 }},
              { breakpoint: 767, settings: { slidesToShow: 2.1, arrows:false }},
              { breakpoint: 480, settings: { slidesToShow: 1.1 }}
            ]
          });
        }, 100); // Short delay ensures visibility before init
      });
    });
  });
});
 
/* end of featured collection */ 